import { NotificationsStore } from "./NotificationsStore";
import { SharedValuesStore } from "./SharedValuesStore";
import { HandoversStore } from "./HandoversStore";

export default {
  notifications: new NotificationsStore(),
  sharedValues: new SharedValuesStore(),
  handovers: new HandoversStore(),
};
